if (!customElements.get('timeline-results')) {
  class TimelineResults extends HTMLElement {
    connectedCallback() {
      this.steps = [...this.querySelectorAll('.timeline-results__step')];
      if (this.steps.length === 0) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target._visible = entry.isIntersecting;
          });

          let highest = 0;
          this.steps.forEach((step, i) => {
            if (step._visible) highest = i;
          });

          this.steps.forEach((step, i) => {
            step.classList.toggle('timeline-results__step--active', i <= highest);
          });
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -50% 0px',
        }
      );

      this.steps.forEach((step) => this.observer.observe(step));
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  customElements.define('timeline-results', TimelineResults);
}
